module.exports = __webpack_public_path__ + "static/media/corporate-services-img26.0dc8a940.jpg";